var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogov2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7132 0.570091C19.7104 -0.668729 25.8745 0.402758 31.8781 1.04758L24.6891 6.99211C24.6891 6.99211 21.8642 6.42658 20.0401 6.45535C18.2334 6.48388 16.7398 6.78413 15.4667 7.12584C9.21426 8.80419 5.50368 15.2424 7.17901 21.5059C8.85435 27.7695 15.2812 31.4866 21.5338 29.8083C31.6675 27.0881 31.7503 15.0493 28.09 16.8621L12.9581 24.5932L32.8578 7.37599C32.8578 7.37599 33.4769 7.92439 33.8242 8.32321C34.2636 8.82791 34.8146 9.72148 34.82 9.73026L34.816 9.7338C35.4674 10.9577 35.9915 12.2746 36.3652 13.6718C39.0089 23.5558 33.1539 33.7156 23.2873 36.3641C13.4206 39.0125 3.27856 33.1467 0.634784 23.2626C-2.00896 13.3784 3.84653 3.21852 13.7132 0.570091Z",
    fill: "white",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogov2);
export default __webpack_public_path__ + "static/media/logov2.5fceb235b5567ed6b04c9d6df2319a26.svg";
export { ForwardRef as ReactComponent };